export default "__VITE_ASSET__Cx5xor$6__"